module.exports = __webpack_public_path__ + "static/media/user-icon4.765012cc.png";